<!--
INTELLECTUAL PROPERTY NOTICE
© Orbit Tickets Ltd. All rights reserved.
This file contains Custom / Included Intellectual Property created for and owned by the Customer as part of an application developed by Kaleida within the Platform.
Custom / Included Intellectual Property may be used, reproduced, adapted, and incorporated into any application, system, or product developed by or on behalf of the Customer, whether or not such application forms part of the Platform, subject always to the terms of the agreement and provided that such use does not include or rely upon any Protected Intellectual Property of Kaleida Ltd.
For the avoidance of doubt, the inclusion of any application within the Platform does not restrict the Customer's right to use Custom / Included Intellectual Property outside of the Platform.
-->
<!-- IP-NOTICE: CUSTOM -->
<body class="email-preview-body" [style.background]="backgroundColorStyle" [style.color]="textColour">
	<table role="presentation" width="100%" cellpadding="0" cellspacing="0" [style.background]="backgroundColorStyle" style="width: 100%">
		<tr>
			<td style="padding: 24px; text-align: center">
				<table role="presentation" width="600" cellpadding="0" cellspacing="0" class="preview-table" [style.borderColor]="borderColour">
					<!-- Optional logo -->
					<tr *ngIf="imageUrl">
						<td class="logo-cell" [style.borderBottomColor]="borderColour">
							<img src="{{ displayImage }}" alt="{{ brandName }} logo" style="max-width: 220px; height: auto; display: block; margin: 0 auto; border: 0" />
						</td>
					</tr>
					<!-- Heading -->
					<tr>
						<td class="heading-cell" [style.background]="headingBackgroundColour" [style.color]="headingTextColour" [style.padding]="'12px 16px'">Booking Confirmation</td>
					</tr>

					<!-- Email body (rich HTML allowed) -->
					<tr>
						<td class="email-body-cell" [style.color]="textColour" [style.padding]="'16px'">
							<div [innerHTML]="displayEmailBody"></div>
						</td>
					</tr>

					<!-- Customer Details -->
					<tr>
						<td class="subheading-cell" [style.background]="subheadingBackgroundColour" [style.color]="subheadingTextColour">Customer Details</td>
					</tr>
					<tr>
						<td class="customer-details-cell" [style.color]="textColour" [style.padding]="'12px 16px'">
							<table role="presentation" width="100%" cellpadding="0" cellspacing="0" style="width: 100%">
								<tr>
									<td style="padding: 6px 0">{{ customer?.firstName }} {{ customer?.lastName }}</td>
								</tr>
								<tr *ngIf="isDispatchPost && customer">
									<td style="padding: 6px 0">
										{{ customer?.line1 }}
										<ng-container *ngIf="customer?.line2"><br />{{ customer?.line2 }}</ng-container>
										<ng-container *ngIf="customer?.city"><br />{{ customer?.city }}</ng-container>
										<ng-container *ngIf="customer?.postcode"><br />{{ customer?.postcode }}</ng-container>
										<ng-container *ngIf="customer?.country"><br />{{ customer?.country }}</ng-container>
									</td>
								</tr>
								<tr>
									<td style="padding: 6px 0">{{ customer?.email }}</td>
								</tr>
								<tr *ngIf="customer?.phone">
									<td style="padding: 6px 0">{{ customer?.phone }}</td>
								</tr>
								<tr>
									<td style="padding: 6px 0">
										Order Number: <strong>{{ orderNumber }}</strong>
									</td>
								</tr>
							</table>
						</td>
					</tr>

					<!-- Booking Details -->
					<tr>
						<td class="section-title-cell" [style.background]="subheadingBackgroundColour" [style.color]="subheadingTextColour">Booking Details</td>
					</tr>
					<tr>
						<td class="details-cell" [style.color]="textColour">
							<table role="presentation" width="100%" cellpadding="0" cellspacing="0" style="width: 100%">
								<tr>
									<td style="padding: 6px 0"><strong style="font-weight: bold">Event:</strong> {{ event?.name }}</td>
								</tr>
								<tr>
									<td style="padding: 6px 0"><strong>Venue:</strong> {{ event?.venue }}</td>
								</tr>
								<tr>
									<td style="padding: 6px 0"><strong>Event Date / Door Time:</strong> {{ event?.dateFormatted }} &nbsp;/&nbsp; {{ event?.doorTimeFormatted }}</td>
								</tr>
								<tr>
									<td style="padding: 6px 0"><strong>Dispatch Method:</strong> {{ dispatch?.method }}</td>
								</tr>
							</table>
						</td>
					</tr>

					<!-- Tickets -->
					<tr>
						<td style="padding: 0 16px 16px 16px">
							<table role="presentation" width="100%" cellpadding="0" cellspacing="0" class="ticket-table" [style.borderColor]="borderColour">
								<tr>
									<th class="ticket-table-header-cell" [style.background]="subheadingBackgroundColour" [style.color]="subheadingTextColour" [style.textAlign]="'left'">Name</th>
									<th class="ticket-table-header-cell" [style.background]="subheadingBackgroundColour" [style.color]="subheadingTextColour" [style.textAlign]="'right'">Face Value</th>
									<th class="ticket-table-header-cell" [style.background]="subheadingBackgroundColour" [style.color]="subheadingTextColour" [style.textAlign]="'right'">Qty</th>
									<th class="ticket-table-header-cell" [style.background]="subheadingBackgroundColour" [style.color]="subheadingTextColour" [style.textAlign]="'right'">Total Face Value</th>
								</tr>
								<tr *ngFor="let ticket of tickets">
									<td class="ticket-table-cell" [style.color]="textColour" [style.borderTopColor]="borderColour">{{ ticket.name }}</td>
									<td class="ticket-table-cell" [style.color]="textColour" [style.borderTopColor]="borderColour" [style.textAlign]="'right'">
										{{ ticket.faceValueGbp }}
									</td>
									<td class="ticket-table-cell" [style.color]="textColour" [style.borderTopColor]="borderColour" [style.textAlign]="'right'">
										{{ ticket.quantity }}
									</td>
									<td class="ticket-table-cell" [style.color]="textColour" [style.borderTopColor]="borderColour" [style.textAlign]="'right'">
										{{ ticket.totalFaceValueGbp }}
									</td>
								</tr>
							</table>
						</td>
					</tr>

					<!-- Payment Plan (optional) -->

					<tr *ngIf="paymentPlan?.hasItems">
						<td style="text-align: center; padding: 0">
							<table role="presentation" width="100%" cellpadding="0" cellspacing="0" style="margin: 0 auto; border: none">
								<tr>
									<td class="subheading-cell" [style.background]="subheadingBackgroundColour" [style.color]="subheadingTextColour">Payment Plan</td>
								</tr>
								<tr>
									<td style="height: 12px; line-height: 12px; font-size: 0">&nbsp;</td>
								</tr>
								<tr>
									<td style="padding: 0 16px 16px 16px">
										<table role="presentation" width="100%" cellpadding="0" cellspacing="0" class="payment-plan-table" [style.borderColor]="borderColour">
											<tr>
												<th class="payment-plan-table-header-cell" [style.background]="subheadingBackgroundColour" [style.color]="subheadingTextColour">Description</th>
												<th class="payment-plan-table-header-cell right-align" [style.background]="subheadingBackgroundColour" [style.color]="subheadingTextColour">Amount</th>
											</tr>
											<tr *ngFor="let item of paymentPlan.items">
												<td class="payment-plan-table-cell" [style.color]="textColour" [style.borderTopColor]="borderColour">{{ item.description }}</td>
												<td class="payment-plan-table-cell right-align" [style.color]="textColour" [style.borderTopColor]="borderColour">{{ item.amountGbp }}</td>
											</tr>
										</table>
									</td>
								</tr>
							</table>
						</td>
					</tr>

					<!-- Order Summary -->
					<tr>
						<td class="subheading-cell" [style.background]="subheadingBackgroundColour" [style.color]="subheadingTextColour">Order Summary</td>
					</tr>
					<tr>
						<td style="height: 16px; line-height: 16px; font-size: 0">&nbsp;</td>
					</tr>
					<tr>
						<td style="padding: 16px">
							<table role="presentation" width="100%" cellpadding="0" cellspacing="0" class="payment-plan-table" [style.borderColor]="borderColour">
								<tr>
									<td class="order-summary-table-cell" [style.color]="textColour" [style.borderTopColor]="borderColour">Face Value Total</td>
									<td class="order-summary-table-cell right-align" [style.color]="textColour" [style.borderTopColor]="borderColour">{{ fees?.faceValueTotalGbp }}</td>
								</tr>
								<tr>
									<td class="order-summary-table-cell" [style.color]="textColour" [style.borderTopColor]="borderColour">Booking Fees</td>
									<td class="order-summary-table-cell right-align" [style.color]="textColour" [style.borderTopColor]="borderColour">{{ fees?.bookingFeesGbp }}</td>
								</tr>
								<tr *ngIf="fees?.showVenueLevyFees">
									<td class="order-summary-table-cell" [style.color]="textColour" [style.borderTopColor]="borderColour">Venue Levy Fees</td>
									<td class="order-summary-table-cell right-align" [style.color]="textColour" [style.borderTopColor]="borderColour">{{ fees?.venueLevyFeesGbp }}</td>
								</tr>
								<tr *ngIf="fees?.showDiscount">
									<td class="order-summary-table-cell" [style.color]="textColour" [style.borderTopColor]="borderColour">Discount</td>
									<td class="order-summary-table-cell right-align" [style.color]="textColour" [style.borderTopColor]="borderColour">{{ fees?.discountGbp }}</td>
								</tr>
								<tr *ngIf="rules?.processingFeeApplied">
									<td class="order-summary-table-cell" [style.color]="textColour" [style.borderTopColor]="borderColour">Processing Fee</td>
									<td class="order-summary-table-cell right-align" [style.color]="textColour" [style.borderTopColor]="borderColour">{{ fees?.processingFeeGbp }}</td>
								</tr>
								<tr>
									<td class="order-summary-table-cell" [style.color]="textColour" [style.borderTopColor]="borderColour">Dispatch Method Fee</td>
									<td class="order-summary-table-cell right-align" [style.color]="textColour" [style.borderTopColor]="borderColour">{{ fees?.dispatchMethodFeeGbp }}</td>
								</tr>
								<tr *ngIf="rules?.cancellationProtectionIncluded">
									<td class="order-summary-table-cell" [style.color]="textColour" [style.borderTopColor]="borderColour">Cancellation Protection Fee</td>
									<td class="order-summary-table-cell right-align" [style.color]="textColour" [style.borderTopColor]="borderColour">{{ fees?.cancellationProtectionFeeGbp }}</td>
								</tr>
								<tr *ngIf="rules?.charityDonation">
									<td class="order-summary-table-cell" [style.color]="textColour" [style.borderTopColor]="borderColour">Charity Donation Amount</td>
									<td class="order-summary-table-cell right-align" [style.color]="textColour" [style.borderTopColor]="borderColour">{{ fees?.charityDonationAmountGbp }}</td>
								</tr>
								<tr>
									<td class="order-summary-table-cell-total" [style.color]="textColour" [style.borderTopColor]="borderColour">TOTAL</td>
									<td class="order-summary-table-cell-total right-align" [style.color]="textColour" [style.borderTopColor]="borderColour">{{ fees?.totalGbp }}</td>
								</tr>
							</table>
						</td>
					</tr>

					<!-- Social / Footer links -->
					<tr *ngIf="hasAnySocialOrFooter">
						<td class="subheading-cell" [style.background]="subheadingBackgroundColour" [style.color]="subheadingTextColour">Stay in touch</td>
					</tr>

					<tr *ngIf="hasSocials">
						<td style="padding: 12px 16px">
							<span *ngFor="let social of socials; let i = index">
								<ng-container *ngIf="i !== 0">&nbsp;&nbsp;</ng-container>
								<a [href]="social.url?.startsWith('http') ? social.url : 'https://' + social.url" target="_blank" style="display: inline-block">
									<img [src]="social.iconUrl" [alt]="social.name" width="20" height="20" style="display: inline-block; border: 0; outline: none; text-decoration: none" />
								</a>
							</span>
						</td>
					</tr>

					<tr *ngIf="footer">
						<td class="footer-cell" [style.color]="textColour" [style.padding]="'8px 16px'">
							<div class="footer-links-row">
								<a *ngIf="footer.termsUrl" href="{{ footer.termsUrl }}" target="_blank" [style.color]="linksColour" style="text-decoration: underline">Terms and Conditions</a>
								<a *ngIf="footer.contactUrl" href="{{ footer.contactUrl }}" target="_blank" [style.color]="linksColour" style="text-decoration: underline">Contact Us</a>
							</div>
						</td>
					</tr>
				</table>
			</td>
		</tr>
	</table>
</body>
